import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  makeStyles,
} from "@material-ui/core";

interface IRecord {
  description: string;
  message: string;
  status: "failed" | "success" | "pending";
}

interface ITableResultCsvFileUpload {
  records: IRecord[];
}

const useStyles = makeStyles({
  table: {
    marginTop: "10px",
    padding: "1rem",
  },
  errorText: {
    color: "#da4040", // red
  },
  successText: {
    color: "#2e7d32", // green
  },
});

const TableResultCsvFileUpload = ({ records }: ITableResultCsvFileUpload) => {
  const classes = useStyles();

  const getStatusClass = (status: string) => {
    switch (status) {
      case "failed":
        return classes.errorText;
      case "success":
        return classes.successText;
      default:
        return "";
    }
  };

  return (
    <TableContainer>
      <Table size="small" className={classes.table}>
        <TableHead>
          <TableRow>
            <TableCell>Description</TableCell>
            <TableCell>Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {records.map((record: IRecord, key: number) => {
            return (
              <TableRow key={`row-${key}`}>
                <TableCell>{record.description}</TableCell>
                <TableCell
                  className={getStatusClass(record.status.toLowerCase())}
                >
                  {record.message}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableResultCsvFileUpload;
